import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LOOKUP from 'constants/lookup';
import * as types from 'constants/actionTypes';
import { poListCrumb } from 'utils/breadcrumbInfo';
import { clearFormInput } from 'actions/FormActions';
import WithRouter from 'custom/withRouter';
import { getPurchaseOrders, importProductsFromCatalog, clearPOList, getVendorsByCountryState, deletePO } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import ExcelUploadAccessoryPO from 'screens/components/basic/ExcelUploadAccessoryPO';
import ExcelUploadCannabisPO from 'screens/components/basic/ExcelUploadCannabisPO';
import ExcelUploadVapePO from 'screens/components/basic/ExcelUploadVapePO';
import FileUpload from 'screens/components/basic/FileUpload';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInputNew from 'screens/components/advanced/DialogInputNew';
import SearchFields from './searchfields';

const pageName = "PoList";
// TODO: Please ensure the code inside any markups are readable, and leave one clear syntax per each line
class PurchaseOrderList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            dialogStatus: false,
            dialogHasImportProductButton: false,
            dialogError: null,
            orderBy: 'DESC',
            sortBy: '',
            confirmDeleteDialog: false,
            itemId: 0
        };

        this.sort = this.sort.bind(this);
        this.openConfirmDeleteDialog = this.openConfirmDeleteDialog.bind(this);
    }

    componentWillMount() {
        this.cleanSearch();
        this.props.getVendors(this.props.store.country, this.props.store.provinceState);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.purchaseOrderImportSuccessTime && newProps.purchaseOrderImportSuccessTime !== this.props.purchaseOrderImportSuccessTime) {
            this.cleanSearch();
            this.props.showSnackbar("PO Imported Successfully.");
            if (newProps.createdSKUs) {
                newProps.showDialog(`The following SKUs are imported: ${newProps.createdSKUs}`);
            }
        }

        if (newProps.purchaseOrderImportFailTime && newProps.purchaseOrderImportFailTime != this.props.purchaseOrderImportFailTime) {
            this.setState({
                dialogError: newProps.purchaseOrderImportFailError,
                dialogHasImportProductButton: newProps.purchaseOrderImportFailError.indexOf('SKUs not found') != -1
            }, this.openDialogStatus());
        }

        if (newProps.importedProductsTime !== undefined && newProps.importedProductsTime !== null && newProps.importedProductsTime !== this.props.importedProductsTime) {
            let importCount = newProps.importedProducts.split(',').length;
            this.props.showError(`Import success, ${importCount} new products are imported. SKUs are ${newProps.importedProducts}`);
        }

        if (newProps.importedProductsErrorTime !== undefined && newProps.importedProductsErrorTime !== null && newProps.importedProductsErrorTime !== this.props.importedProductsErrorTime) {
            this.props.showError(`${newProps.importedProductsError}`);
        }

        if (newProps.deletePOSuccess && newProps.deletePOSuccess != this.props.deletePOSuccess) {
            this.cleanSearch();
            this.props.showError(`PO delete success!`);
        }
    }

    componentWillUnmount() {
        this.props.clearPOList();
    }

    getPurchaseOrders = () => {
        const model = {
            id: this.props.purchaseNumber || null,
            branchId: this.props.branchId || 0,
            description: "",
            paymentDueDate: this.props.date || null,
            dateExpected: this.props.dateExpected || null,
            createdDate: null,
            status: this.props.status || "None",
            total: null,
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            vendorId:this.props.vendorId || 0,
        }

        this.props.getPurchaseOrders(model);
    }

    editPurchaseOrder = (id) => {
        this.props.navigate(`/purchaseOrder/edit/${id}`);
    }

    receivePurchaseOrder = (id) => {
        this.props.navigate(`/purchaseOrder/receive/${id}`);
    }

    addPurchaseOrder = () => {
        this.props.navigate("/purchaseorder/add");
    }

    cleanSearch = () => {
        this.props.clearFormInput('PoListPoFilter');
        this.props.clearFormInput('PoListDueDateFilter');
        this.props.clearFormInput('PoListDateExpectedFilter');
        this.props.clearFormInput('PoListStatus');

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                sortBy: "",
                orderBy: "DESC"
            };
        }, () => this.getPurchaseOrders());
    }

    downloadPOAccessoriesTemplate = () => {
        window.location.href = this.props.apiURL + `unauthorized/dlaccessoriestemplate`;
    }

    downloadPOCannabisTemplate = () => {
        window.location.href = this.props.apiURL + `unauthorized/dlcannabistemplate`;
    }

    downloadPOVapeTemplate = () => {
        window.location.href = this.props.apiURL + `unauthorized/dlvapetemplate`;
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getPurchaseOrders);
    }

    search = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getPurchaseOrders);
    }

    openDialogStatus = () => {
        this.setState({ dialogStatus: true });
    }

    closeDialogStatus = () => {
        this.setState({ dialogStatus: false });
    }

    importFromCatalogue = () => {
        this.props.importProductsFromCatalog(this.props.branchId);
        this.closeDialogStatus();
    }

    loadVendorOptions = (vendors) => {
        let options = [];
        vendors.map((vendor) => {
            if (vendor.status === 'Active') {
                options.push(
                    { text: vendor.name, value: parseInt(vendor.id) }
                );
            }
        });
        return options;
    }

    sort(sortBy) {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy: sortBy
            }
        }, this.getPurchaseOrders);
    }

    openConfirmDeleteDialog = (itemId) => {
        this.setState({ confirmDeleteDialog: true, itemId: itemId });
    };

    closeConfirmDeleteDialog = () => {
        this.setState({ confirmDeleteDialog: false });
    };

    confirmDeletePO = (poId) => {
        this.setState({ confirmDeleteDialog: false });
        this.props.deletePO(poId);
    }

    isWithinSevenDays = (inputDateStr) => {
        // Parse the input date and get the current date
        const inputDate = new Date(inputDateStr);
        const currentDate = new Date();

        // Set the time of both dates to 00:00:00 for accurate day comparison
        inputDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        // Calculate the difference in days
        const diffTime = Math.abs(inputDate - currentDate);
        const diffDays = diffTime / (1000 * 60 * 60 * 24); // Convert milliseconds to days

        // Check if the difference is within 3 days
        return diffDays <= 7;
    }
    render() {
        const p = this.props;
        const s = this.state;

        const listPurchaseOrders = (p.purchaseOrders || []).map((item, index) => {
            const total = item.total || 0;

            return {
                ID: (<Link className="edit-link" to={`/purchaseOrder/edit/${item.id}`}>{item.id}</Link>),
                Supplier: item.vendor,
                Description: (<Link to={`/purchaseOrder/edit/${item.id}`}>{item.description}</Link>),
                Total: p.canViewPOTotalAmount ? `$ ${total.toFixed(2)}` : 'N.A.',
                PaymentDueDate: item.paymentDueDate && item.paymentDueDate.split("T")[0],
                DateExpected: item.dateExpected && item.dateExpected.split("T")[0],
                Qty: item.products ? item.products.length : 0,
                Status: item.status,
                EditIcons: <div className="column-links-po">
                    {p.canAddEditPO ? <Button id={`editPO-${index}`} type="IconEditButton" mini={true} onTouchTap={() => this.editPurchaseOrder(item.id)} /> : ""}
                    {(item.status !== 'Closed' && item.status !== 'Opened') ? <Button id={`receivePO-${index}`} type="IconButton" className="glyphicon glyphicon-save" icon={<FileDownloadIcon />} onTouchTap={() => this.receivePurchaseOrder(item.id)} /> : ''}
                </div>,
                DeleteIcon: <div className="column-links-po">
                    <span>
                        {
                            this.isWithinSevenDays(item.creationDate) ?
                                <Button
                                    mini={true}
                                    type="IconDeleteButton"
                                    id={`deletePO-${index}`}
                                    className="glyphicon glyphicon-remove-circle"
                                    onTouchTap={() => this.openConfirmDeleteDialog(item.id)}
                                /> : ''
                        }
                    </span>
                </div>
            };
        });

        let importErrorButtons = [
            <Button
                key={1}
                name="buttonRemoveItem"
                label="Confirm"
                primary={true}
                onTouchTap={() => this.closeDialogStatus()} />
        ];

        const buttonWidth = "280px"

        return (
            <Grid headerContent={poListCrumb}>
                <PageHeaderWithButton title="Purchase Orders">
                    {
                        p.canAddEditPO &&
                        (
                            <div className="row page-buttons po-buttons">
                                <div className="col-lg-12 p-0">
                                    {!p.isVape &&
                                        <FileUpload
                                            buttonStyles={{ width: buttonWidth, margin: '0 5px' }}
                                            branchId={p.branchId}
                                            className="btn-span-upload"
                                        />}
                                    
                                    <Button
                                        style={{ width: buttonWidth, margin: '0 5px' }}
                                        type="AddButton"
                                        mini={true}
                                        label="ADD NEW Purchase Orders"
                                        className="bg-light-green"
                                        onTouchTap={p.callSaveView}
                                        id="addNewPOButton"
                                    />
                                </div>
                                <div className="col-xs-lg p-0">
                                    <Button
                                        style={{ width: buttonWidth, margin: '0 5px' }}
                                        mini={true}
                                        label="DOWNLOAD ACCESSORIES TEMPLATE"
                                        className="bg-gray-Purple-p POListBtn btnNewBrandPOS"
                                        onTouchTap={this.downloadPOAccessoriesTemplate}
                                        primary={true}
                                        id="downloadAccessoryTemplate"
                                    />
                                    <ExcelUploadAccessoryPO
                                        buttonStyles={{ width: buttonWidth, margin: ' 0 5px' }}
                                        className="btn-span-upload"
                                        branchId={p.branchId} />
                                </div>
                                {
                                    p.isVape ? (
                                        <div className="col-xs-12 p-0">
                                            <Button
                                                style={{ width: buttonWidth }}
                                                mini={true}
                                                label="DOWNLOAD VAPE TEMPLATE"
                                                className="bg-gray-Purple-p POListBtn btnNewBrandPOS"
                                                onTouchTap={this.downloadPOVapeTemplate}
                                                primary={true}
                                                id="downloadVapeTemplate"
                                            />
                                            <ExcelUploadVapePO
                                                buttonStyles={{ width: buttonWidth, margin: '0 5px' }}
                                                branchId={p.branchId}
                                                />
                                        </div>
                                    ) : (
                                        <div className="col-xs-12 p-0 d-flex align-items-center">
                                            <Button
                                                style={{ width: buttonWidth, margin: '0 5px' }}
                                                mini={true}
                                                label="DOWNLOAD CANNABIS TEMPLATE"
                                                className="bg-gray-Purple-p POListBtn btnNewBrandPOS"
                                                onTouchTap={this.downloadPOCannabisTemplate}
                                                id="downloadCannabisTemplate"
                                            />
                                            <ExcelUploadCannabisPO
                                                buttonStyles={{ width: buttonWidth }}
                                                branchId={p.branchId} />
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }
                </PageHeaderWithButton>
                <CardSimple className="p-1">
                    <SearchFields
                        pageName={pageName}
                        cleanSearch={this.cleanSearch}
                        search={this.search}
                        add={this.addPurchaseOrder}
                        loadVendorOptions={this.loadVendorOptions(p.vendors || [])}
                    />
                </CardSimple>
                <CardSimple>
                    <GenericTable
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={false}
                        columns={LOOKUP.purchaseOrder.tableColumns}
                        rows={listPurchaseOrders || []}
                        orderBy={this.state.orderBy}
                        sortBy={this.state.sortBy}
                        sort={this.sort}
                        stripedRows={true}
                    />
                    <Pagination
                        length={p.purchaseOrdersLenght || 0}
                        itemsPerPage={s.itemsPerPage}
                        activePage={s.activePage}
                        onPageChange={(e) => this.changePage(e)}
                        maxButtons={4}
                    />
                </CardSimple>
                <DialogInputNew
                    title="Import Error" 
                    handleClose={() => this.closeDialogStatus()}
                    actions={[importErrorButtons]}
                    open={this.state.dialogStatus}>
                    {this.state.dialogError}
                </DialogInputNew>
                <DialogInputNew
                    title="CONFIRM DELETE" handleClose={() => this.closeConfirmDeleteDialog()}
                    open={this.state.confirmDeleteDialog}
                    autoScrollBodyContent={true}
                    style={{ zIndex: "950" }}
                    actions={[
                        <Button
                            key={1}
                            name="ConfirmDelete"
                            label="Delete"
                            primary={true}
                            className="btn-space-20"
                            onTouchTap={() => this.confirmDeletePO(this.state.itemId)}
                        />
                    ]}
                    contentStyle={{ width: "65%" }}
                >
                    <div>
                        <div className="row">
                            <div className="col-lg-12">
                                <h4 className="purpleText">
                                    Are you sure you wish to delete this purchase order? All received products will be unreceived, and inventory will be updated for all received products. If this will cause negative inventory, the delete will fail. Only PO created within 7 days can be deleted.
                                </h4>
                            </div>
                        </div>
                    </div>
                </DialogInputNew>
            </Grid>
        );
    }
}


function mapStatetoProps(state) {
    return {
        purchaseOrders: state.entity.purchaseOrderList,
        purchaseOrdersLenght: state.entity.purchaseOrderListLength,
        branchId: state.common.branchId,
        purchaseNumber: state.form.PoListPoFilter,
        date: state.form.PoListDueDateFilter ? new Date(state.form['PoListDueDateFilter']) : null,
        dateExpected: state.form.PoListDateExpectedFilter ? new Date(state.form['PoListDateExpectedFilter']) : null,
        status: state.form.PoListStatus,
        apiURL: state.common.store.apiUrl,
        canAddEditPO: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanAddEditPO")),
        canViewPOTotalAmount: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanViewPOTotalAmount")),
        purchaseOrderImportFailTime: state.entity.purchaseOrderImportFailTime,
        purchaseOrderImportFailError: state.entity.purchaseOrderImportFailError,
        importedProducts: state.entity.importedProducts,
        importedProductsError: state.entity.importedProductsError,
        importedProductsTime: state.entity.importedProductsTime,
        importedProductsErrorTime: state.entity.importedProductsErrorTime,
        isVape: state.common.applicationSettings.isVape,
        purchaseOrderImportSuccessTime: state.entity.purchaseOrderImportSuccessTime,
        createdSKUs: state.entity.createdSKUs,
        deletePOSuccess: state.entity.deletePOSuccess,
        vendors: state.entity.vendorList,
        store: state.common.store,
        vendorId : state.form.PoListSupplier
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        getVendors: (country, provinceState) => dispatch(getVendorsByCountryState(country, provinceState)),
        getPurchaseOrders: (model) => dispatch(getPurchaseOrders(model)),
        importProductsFromCatalog: (branchId) => dispatch(importProductsFromCatalog(branchId)),
        showError: (message) => dispatch(showError(message)),
        clearPOList: () => dispatch(clearPOList()),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showDialog: (message) => dispatch({ type: types.DIALOG_ALERT_OPEN, message: message }),
        deletePO: (poId) => dispatch(deletePO(poId))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(PurchaseOrderList));
